import {Injectable} from '@angular/core';
import {AbstractService} from './abstract.service';
import {ApiVersion} from '../constants/apis';
import {environment} from '../../environments/environment';
import {LibraryApiResponse} from '../models/library-api-response';
import {Library, LibraryDetails} from '../models/library.model';
import {UnbindPoliciesDto} from '../models/retention.model';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PolicyType} from '../constants/retention-constants';
import {CustomHttpParameterCodec} from '../utils/http-encoder';


@Injectable({
  providedIn: 'root'
})
export class LibraryService extends AbstractService {

  constructor(private http: HttpClient) {
    super();
  }

  searchLibraries(filter: string, query: string, pageSize: number, nextPageToken?: string): Observable<LibraryApiResponse> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'libraries');
    let params = new HttpParams({encoder: new CustomHttpParameterCodec()})
      .set('filter', String(filter))
      .set('pageSize', String(pageSize));

    if (query) {
      params = params.append('query', query);
    }

    if (nextPageToken) {
      params = params.append('nextPageToken', nextPageToken);
    }

    return this.http.get<LibraryApiResponse>(url, {params});
  }

  details(libraryId: string): Observable<LibraryDetails> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'library/' + libraryId + '/configuration');
    return this.http.get<LibraryDetails>(url);
  }


  recalculate(libraryId: string): Observable<LibraryDetails> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'library/' + libraryId + '/state/recalculate');
    return this.http.post<LibraryDetails>(url, null);
  }

  unbindAll(libraryId: string): Observable<UnbindPoliciesDto> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'library/' + libraryId + '/policies/bindings');
    return this.http.delete<UnbindPoliciesDto>(url);
  }

  getLibrarySettingsUrl(libraryId: string): string {
    return environment.aodocsUrl + 'editor.html?/#Menu_configlibrarySettings/LibraryId_' + libraryId;
  }

  getConfigClassListUrl(libraryId: string): string {
    return environment.aodocsUrl + 'editor.html?/#Menu_configclassList/LibraryId_' + libraryId;
  }

}
